import React from 'react';
import PropTypes from 'prop-types';

import Section from 'components/structure/Section';
import TabNavLinks from 'components/tab/TabNavLinks/TabNavLinks';

import SectionHero from './components/SectionHero/SectionHero';

const tabLinkData = [
  {
    linkText: 'ABOUT_US.PAGE_HEADING.TAB',
    href: '/sobre-nos',
  },
  {
    linkText: 'CAREERS.PAGE_HEADING.TAB',
    href: '/carreiras',
  },
  {
    linkText: 'PRESS.PAGE_HEADING.TAB',
    href: '/imprensa',
  },
];

function AboutPage({ children }) {
  return (
    <>
      <SectionHero />
      <Section minHeight="1em">
        <TabNavLinks links={tabLinkData} />
      </Section>

      {children}
    </>
  );
}

AboutPage.propTypes = {
  children: PropTypes.node.isRequired,
};

export default React.memo(AboutPage);
